const STATUS_CONFIG = {
  PENDING_VERIFICATION: {
    value: 'pending',
    label: 'Do weryfikacji',
  },
  PARTIALLY_VERIFIED: {
    value: 'partially_approved',
    label: 'Zatwierdzono częściowo',
  },
  FULLY_VERIFIED: {
    value: 'approved',
    label: 'Zatwierdzono',
  },
  REJECTED: {
    value: 'rejected',
    label: 'Odrzucono',
  },
  BOOKED: {
    value: 'booked',
    label: 'Zaksięgowano',
  },
  FROM_PUZZLE_TAX: {
    value: 'from_puzzle_tax',
    label: 'Wystawiona w PuzzleTax',
  },
};

const DIRECTION_CONFIG = {
  PURCHASE: {
    value: 'purchase',
    label: 'Zakupowa'
  },
  SALE: {
    value: 'sale',
    label: 'Sprzedażowa'
  }
}

export const KSEF_PURCHASE_STATUS = {
  PENDING_VERIFICATION: STATUS_CONFIG.PENDING_VERIFICATION.value,
  PARTIALLY_VERIFIED: STATUS_CONFIG.PARTIALLY_VERIFIED.value,
  FULLY_VERIFIED: STATUS_CONFIG.FULLY_VERIFIED.value,
  REJECTED: STATUS_CONFIG.REJECTED.value,
  BOOKED: STATUS_CONFIG.BOOKED.value,
  FROM_PUZZLE_TAX: STATUS_CONFIG.FROM_PUZZLE_TAX.value,
};

export const KSEF_PURCHASE_STATUS_LABELS = {
  PENDING_VERIFICATION: STATUS_CONFIG.PENDING_VERIFICATION.label,
  PARTIALLY_VERIFIED: STATUS_CONFIG.PARTIALLY_VERIFIED.label,
  FULLY_VERIFIED: STATUS_CONFIG.FULLY_VERIFIED.label,
  REJECTED: STATUS_CONFIG.REJECTED.label,
  BOOKED: STATUS_CONFIG.BOOKED.label,
  FROM_PUZZLE_TAX: STATUS_CONFIG.FROM_PUZZLE_TAX.label,
};

export const KSEF_INVOICE_DIRECTION = {
  PURCHASE: DIRECTION_CONFIG.PURCHASE.value,
  SALE: DIRECTION_CONFIG.SALE.value
}

export const KSEF_INVOICE_DIRECTION_LABELS = {
  PURCHASE: DIRECTION_CONFIG.PURCHASE.label,
  SALE: DIRECTION_CONFIG.SALE.label
}

const INVOICE_TYPE_CONFIG = {
  VAT: { value: 'VAT', label: 'VAT', color: 'primary' },
  KOR: { value: 'KOR', label: 'KOR', color: 'warning' },
  ZAL: { value: 'ZAL', label: 'ZAL', color: 'primary' },
  ROZ: { value: 'ROZ', label: 'ROZ', color: 'success' },
  UPR: { value: 'UPR', label: 'UPR', color: 'gray' },
  KOR_ZAL: { value: 'KOR_ZAL', label: 'KOR/ZAL', color: 'warning' },
  KOR_ROZ: { value: 'KOR_ROZ', label: 'KOR/ROZ', color: 'warning' },
};

export const KSEF_INVOICE_TYPE = {
  VAT: INVOICE_TYPE_CONFIG.VAT.value,
  KOR: INVOICE_TYPE_CONFIG.KOR.value,
  ZAL: INVOICE_TYPE_CONFIG.ZAL.value,
  ROZ: INVOICE_TYPE_CONFIG.ROZ.value,
  UPR: INVOICE_TYPE_CONFIG.UPR.value,
  KOR_ZAL: INVOICE_TYPE_CONFIG.KOR_ZAL.value,
  KOR_ROZ: INVOICE_TYPE_CONFIG.KOR_ROZ.value,
};

export const getKsefInvoiceTypeConfig = (type) =>
  Object.values(INVOICE_TYPE_CONFIG).find((c) => c.value === type) || null;

export const getKsefInvoiceTypeOptions = () =>
  Object.values(INVOICE_TYPE_CONFIG).map(({ value, label }) => ({ value, label }));

export const getKsefPurchaseStatusOptions = () =>
  Object.values(STATUS_CONFIG).map(({ value, label }) => ({ value, label }));

export const getKsefInvoiceDirectionOptions = () =>
  Object.values(DIRECTION_CONFIG).map(({ value, label }) => ({ value, label }));

export const MARGIN_PROCEDURE_LABELS = {
  used_goods: 'Towary używane',
  art: 'Dzieła sztuki',
  collectibles_and_antiques: 'Przedmioty kolekcjonerskie i antyki',
  travel_agency: 'Biura podróży',
};
